import { RouteRecordRaw, RouterView } from 'vue-router'

export default {
    name: 'olympic',
    path: '/olympic',
    redirect: '/olympic/home',
    component: RouterView,
    children: [
        {
            name: 'olympicHome',
            path: 'home',
            meta: {
                title: '奥运会篮球比赛分析',
            },
            component: () => import('@/view/olympic/player-team-report/index.vue'),
        },
        {
            name: 'team',
            path: 'team',
            meta: {
                title: '奥运会篮球比赛分析',
            },
            component: () => import('@/view/olympic/player-team-report/team.vue'),
        },
        {
            name: 'player',
            path: 'player',
            meta: {
                title: '奥运会篮球比赛分析',
            },
            component: () => import('@/view/olympic/player-team-report/player.vue'),
        },
        {
            name: '3v3-home',
            path: '3v3-home',
            meta: {
                title: '奥运会篮球比赛分析',
            },
            component: () => import('@/view/olympic/digtal-3v3/Home.vue'),
        },
        {
            name: '3v3-defensive',
            path: '3v3-defensive',
            meta: {
                title: '球员详情-奥运会篮球比赛分析',
            },
            component: () => import('@/view/olympic/digtal-3v3/Defensive.vue'),
        },
        {
            name: '3v3-offensive',
            path: '3v3-offensive',
            meta: {
                title: '球员详情-奥运会篮球比赛分析',
            },
            component: () => import('@/view/olympic/digtal-3v3/Offensive.vue'),
        },
        {
            name: '5v5-home',
            path: '5v5-home',
            meta: {
                title: '赛事列表-奥运会篮球比赛分析',
            },
            component: () => import('@/view/olympic/digtal-5v5/Home.vue'),
        },
        {
            name: '5v5-lineup',
            path: '5v5-lineup',
            meta: {
                title: '球员详情-奥运会篮球比赛分析',
            },
            component: () => import('@/view/olympic/digtal-5v5/Lineup.vue'),
        },
        {
            name: '5v5-offensiveWay',
            path: '5v5-offensiveWay',
            meta: {
                title: '球员详情-奥运会篮球比赛分析',
            },
            component: () => import('@/view/olympic/digtal-5v5/OffensiveWay.vue'),
        },
        {
            name: '5v5-panelData',
            path: '5v5-panelData',
            meta: {
                title: '球员详情-奥运会篮球比赛分析',
            },
            component: () => import('@/view/olympic/digtal-5v5/PanelData.vue'),
        },
    ],
} as RouteRecordRaw
